import React from "react";
import { PureComponent } from "react";
import { Toast } from "react-bootstrap";
import styles from './ToastMessage.module.css';
import classnames from 'classnames';

type ToastMessageProps = {
  message: string | null,
  description: string | null,
  type: "success" | "danger" | "info" | undefined,
  clearMessage: () => {},
}

export class ToastMessage extends PureComponent<ToastMessageProps> {
  render() {
    return (
      <Toast
        className={classnames(
          styles.root,
          { [styles.success]: this.props.type === 'success' },
          { [styles.danger]: this.props.type === 'danger' },
          { [styles.info]: this.props.type === 'info' },
          { [styles.top]: this.props.message !== null }
        )}
        onClose={() => this.props.clearMessage()}
        show={this.props.message !== null}
        delay={6000}
        autohide
      >
        <Toast.Header className={classnames(
          { [styles.success]: this.props.type === 'success' },
          { [styles.danger]: this.props.type === 'danger' },
          { [styles.info]: this.props.type === 'info' },
        )}>
        <strong className="mr-auto">{this.props.message}</strong>
        </Toast.Header>
        { this.props.description &&
          <Toast.Body><div dangerouslySetInnerHTML={{__html: this.props.description}}></div></Toast.Body> }
      </Toast>
    );
  }
}

export default ToastMessage;
